// src/data/serumsImg/renewalImages.js

export const renewalImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages_Renewal.png"),
  imgModal: require("../../img/jetCare-serums/Glycolic Acid_Set.png"),
  productsImages: {
    "Glycolic-acid-gentle-exfoliation-5%": {
      image: require("../../img/jetCare-serums/Renewal_GA5.png"),
      imageBig: require("../../img/jetCare-serums/Glycolic Acid_5.png")
    },
    "glycolic-acid-medium-exfoliation-10%": {
      image: require("../../img/jetCare-serums/GA10.png"),
      imageBig: require("../../img/jetCare-serums/Glycolic Acid_10.png")
    },
    "glycolic-acid-powerful-exfoliation-16%": {
      image: require("../../img/jetCare-serums/GA16.png"),
      imageBig: require("../../img/jetCare-serums/Glycolic Acid_16.png")
    },
    "mandelic-salicylic": {
      image: require("../../img/jetCare-serums/Renewal_MS.7_SIT.png"),
      imageBig: require("../../img/jetCare-serums/Renewal_M&S.png")
    }
  }
};
